import { AbstractPlayer } from './abstract-player'

export class VideoPlayerStore {
    private players: AbstractPlayer[] = []

    private static _instance: VideoPlayerStore
    public static getInstance(): VideoPlayerStore {
        return this._instance || (this._instance = new this())
    }

    public get mainPlayer(): AbstractPlayer {
        return this.players[0]
    }

    public add(player: AbstractPlayer): void {
        this.players.push(player)
    }

    public pauseAllOther(component: AbstractPlayer): void {
        this.players.forEach((player: AbstractPlayer) => {
            if (player !== component) {
                player.pause()
            }
        })
    }

    public isFeatured(component: AbstractPlayer): boolean {
        return this.mainPlayer === component
    }
}
